'use client';

import { createContext, useContext } from 'react';
import type { SheetPlacements } from './types';

type ContextType = {
  onRequestClose: () => void;
  isShowing: boolean;
  id: string | null;
  initialFocusRef: any;
  placement: SheetPlacements;
};

export const SheetContext = createContext<ContextType>({
  onRequestClose: () => {},
  isShowing: false,
  id: null,
  initialFocusRef: null,
  placement: 'left',
});

export const useSheetContext = () => {
  return useContext(SheetContext);
};

/**
 * Set the initially focused element for the sheet.
 *
 * @example
 * const ref = useSheetInitialFocusRef();
 * return <input ref={ref} />
 */

export const useSheetInitialFocusRef = () => {
  const { initialFocusRef } = useSheetContext();
  return initialFocusRef;
};
